<div class="dashboard" *ngIf="aggregationsModel">
    <div class="total-header">
        {{ "visibilityDashboardPage.totalTitle" | labelsProvider }}
    </div>

    <app-category-amount
        class="automations"
        [resourcesAmount]="totalResourcesOfCategoryData[automationResourceCategory] || 0"
        [resourcesCategory]="automationResourceCategory"
        [filterOptions]="selectedFilters">
    </app-category-amount>

    <app-category-amount
        class="applications"
        [resourcesAmount]="totalResourcesOfCategoryData[applicationResourceCategory] || 0"
        [resourcesCategory]="applicationResourceCategory"
        [filterOptions]="selectedFilters">
    </app-category-amount>
    <!--
    <app-category-amount class="bots" [resourcesAmount]="totalResourcesOfCategoryData[botResourceCategory] || 0"
        [resourcesCategory]="botResourceCategory" [filterOptions]="selectedFilters">
    </app-category-amount> -->

    <app-category-amount
        class="agents"
        [resourcesAmount]="totalResourcesOfCategoryData[botResourceCategory] || 0"
        [resourcesCategory]="botResourceCategory"
        [filterOptions]="selectedFilters">
    </app-category-amount>

    <app-category-amount
        class="connections"
        [resourcesAmount]="totalResourcesOfCategoryData[connectionResourceCategory] || 0"
        [resourcesCategory]="connectionResourceCategory"
        [filterOptions]="selectedFilters">
    </app-category-amount>

    <app-category-amount
        class="environments"
        [resourcesAmount]="totalResourcesOfCategoryData[environmentResourceCategory] || 0"
        [resourcesCategory]="environmentResourceCategory"
        [filterOptions]="selectedFilters">
    </app-category-amount>

    <app-category-amount
        class="dataStorage"
        [resourcesAmount]="totalResourcesOfCategoryData[dataStorageResourceCategory] || 0"
        [resourcesCategory]="dataStorageResourceCategory"
        [filterOptions]="selectedFilters">
    </app-category-amount>

    <div class="builders-header">
        {{ "visibilityDashboardPage.buildersAdoptionAndGrowthTitle" | labelsProvider }}
    </div>

    <app-top-builders-data-chart
        class="top-builders"
        [title]="'visibilityDashboardPage.topBuildersTitle' | labelsProvider"
        [tooltip]="'visibilityDashboardPage.topBuildersTooltip' | labelsProvider"
        [seriesData]="topBuilders"
        [filterOptions]="selectedFilters">
    </app-top-builders-data-chart>

    <app-line-chart
        class="builders-adoption"
        [title]="'visibilityDashboardPage.buildersAdoptionTitle' | labelsProvider"
        [tooltip]="'visibilityDashboardPage.buildersAdoptionTooltip' | labelsProvider"
        [seriesDetails]="buildersAdoption">
    </app-line-chart>

    <div class="management-header">
        {{ "visibilityDashboardPage.managementAndCleanupTitle" | labelsProvider }}
    </div>

    <app-horizontal-bar-chart
        class="unused-resources"
        [title]="'visibilityDashboardPage.unusedResourcesTitle' | labelsProvider"
        [tooltip]="'visibilityDashboardPage.unusedResourcesTooltip' | labelsProvider"
        [seriesData]="this.unusedResources">
    </app-horizontal-bar-chart>

    <app-horizontal-bar-chart
        class="orphan-resources"
        [title]="'visibilityDashboardPage.orphanResourcesTitle' | labelsProvider"
        [tooltip]="'visibilityDashboardPage.orphanResourcesTooltip' | labelsProvider"
        [seriesData]="this.orphanResources">
    </app-horizontal-bar-chart>
</div>
